import { render, staticRenderFns } from "./ProductOverview1.vue?vue&type=template&id=cc633158&"
import script from "./ProductOverview1.vue?vue&type=script&lang=js&"
export * from "./ProductOverview1.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverview1.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
